import React from 'react';
import classNames from 'classnames';

export default function LearnerSelectableResponse({
  response,
  selectResponse,
}) {
  const responseText = response.subject || response.text;
  return (
    <button
      key={response.id}
      className="OnDemandPracticeConversation-chatBubble OnDemandPracticeConversation-chatBubbleRight OnDemandPracticeConversation-chatBubbleRight--selectable CustomColor--color"
      onClick={() => selectResponse(response)}
      onKeyDown={e => e.key === 'Enter' && selectResponse(response)}
      tabIndex="0"
      type="button"
    >
      <p
        className={classNames('mb-0', {
          'fs-i':
            responseText ===
              t(
                'practice.on_demand_practice.editor.conversations.correct_response_filler',
              ) ||
            responseText ===
              t(
                'practice.on_demand_practice.editor.conversations.incorrect_response_filler',
              ),
        })}
      >
        {responseText}
      </p>
    </button>
  );
}
